import React, { Component } from "react";
import BulkCmdHistory from "./BulkCmdHistory";
import './BulkImmobWindow.css'
class BulkImmobWindow extends Component {
    render(){
        return (
            <div className="bulk-immob-container">
                <div className="sub-container">
                    <BulkCmdHistory />
                </div>
            </div>
        )
    }
}
export default BulkImmobWindow